module.exports = __webpack_public_path__ + "static/img/4.421ad0e1.webp";